import * as actionTypes from "constants/ActionTypes";

const companyUser = (state = { isLoaded: false, data: {} }, action) => {
  switch (action.type) {
    case actionTypes.GET_COMPANY_USER.REQUEST:
      return {
        ...state,
        isLoaded: false,
      };
    case actionTypes.GET_COMPANY_USER.SUCCESS: {
      return {
        ...state,
        ...action.data,
        isLoaded: true,
      };
    }
    case actionTypes.GET_COMPANY_USER.FAILURE:
      return {
        ...state,
        ...action.data,
        isLoaded: true,
      };
    default:
      return state;
  }
};

export default companyUser;



// WEBPACK FOOTER //
// ./app/reducers/integrators/user.js